/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Submitted_TextInputs */

const en_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your embed job has been submitted. You will be notified when it is complete.`)
};

const fr_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre tache d'incrustation a ete soumise. Vous serez notifie lorsqu'elle sera terminee.`)
};

const de_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihr Einbettungsauftrag wurde übermittelt. Sie werden benachrichtigt, sobald er abgeschlossen ist.`)
};

const it_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo lavoro di incorporamento è stato inviato. Riceverai una notifica al termine.`)
};

const ru_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша заявка на встраивание отправлена. Вы получите уведомление, когда она будет завершена.`)
};

const es_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu trabajo de inserción se ha enviado. Recibirás una notificación cuando esté completo.`)
};

const zh_cn2_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您的嵌入任务已提交。完成后，您将收到通知。`)
};

const ja_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`埋め込みジョブが送信されました。完了すると通知されます。`)
};

const hi_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका एम्बेड जॉब सबमिट हो गया है। पूरा होने पर आपको सूचित किया जाएगा।`)
};

const pt_pt2_embed_captions_submitted_text = /** @type {(inputs: Embed_Captions_Submitted_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu pedido de incorporação foi enviado. Você será notificado quando estiver concluído.`)
};

/**
* | output |
* | --- |
* | "Your embed job has been submitted. You will be notified when it is complete." |
*
* @param {Embed_Captions_Submitted_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_submitted_text = /** @type {((inputs?: Embed_Captions_Submitted_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Submitted_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_submitted_text(inputs)
	if (locale === "de") return de_embed_captions_submitted_text(inputs)
	if (locale === "it") return it_embed_captions_submitted_text(inputs)
	if (locale === "ru") return ru_embed_captions_submitted_text(inputs)
	if (locale === "es") return es_embed_captions_submitted_text(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_submitted_text(inputs)
	if (locale === "ja") return ja_embed_captions_submitted_text(inputs)
	if (locale === "hi") return hi_embed_captions_submitted_text(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_submitted_text(inputs)
	return en_embed_captions_submitted_text(inputs)
});